/**
 * Strips Shopify Admin GID prefixes for read-only UI display.
 * Example: gid://shopify/Product/123 -> 123
 */
export const formatShopifyGidForDisplay = (raw) => {
  if (raw === null || raw === undefined) return raw;
  const s = String(raw).trim();
  if (s === "" || s === "-") return s;

  const productPrefix = "gid://shopify/Product/";
  const variantPrefix = "gid://shopify/ProductVariant/";
  if (s.startsWith(productPrefix)) return s.slice(productPrefix.length);
  if (s.startsWith(variantPrefix)) return s.slice(variantPrefix.length);
  return s;
};
